import {
  demoUser,
  demoStreams,
  demoDrops,
  demoNfts,
  demoMarketplace,
  demoSales,
  demoTips,
  demoProposals,
  demoTreasury,
  demoAnalytics
} from './demoData';

// User services
export const getDemoUser = () => {
  return Promise.resolve(demoUser);
};

export const getDemoUserProfile = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoUser);
  }
  return Promise.resolve({
    ...demoUser,
    id: userId,
    walletAddress: userId,
    username: 'User' + userId.substring(0, 6),
  });
};

// Stream services
export const getDemoStreams = () => {
  return Promise.resolve(demoStreams);
};

export const getDemoStream = (streamId: string) => {
  const stream = demoStreams.find(s => s.id === streamId);
  if (stream) {
    return Promise.resolve(stream);
  }
  return Promise.reject(new Error('Stream not found'));
};

export const getDemoUserStreams = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoStreams.filter(s => s.creatorId === demoUser.id));
  }
  return Promise.resolve([]);
};

// Drop services
export const getDemoDrops = () => {
  return Promise.resolve(demoDrops);
};

export const getDemoDrop = (dropId: string) => {
  const drop = demoDrops.find(d => d.id === dropId);
  if (drop) {
    return Promise.resolve(drop);
  }
  return Promise.reject(new Error('Drop not found'));
};

export const getDemoUserDrops = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoDrops.filter(d => d.creatorId === demoUser.id));
  }
  return Promise.resolve([]);
};

// NFT services
export const getDemoNfts = () => {
  return Promise.resolve(demoNfts);
};

export const getDemoNft = (nftId: string) => {
  const nft = demoNfts.find(n => n.id === nftId);
  if (nft) {
    return Promise.resolve(nft);
  }
  return Promise.reject(new Error('NFT not found'));
};

export const getDemoUserNfts = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoNfts.filter(n => n.owner === demoUser.walletAddress));
  }
  return Promise.resolve([]);
};

export const getDemoDropNfts = (dropId: string) => {
  return Promise.resolve(demoNfts.filter(n => n.dropId === dropId));
};

// Marketplace services
export const getDemoMarketplaceListings = () => {
  return Promise.resolve(demoMarketplace);
};

export const getDemoMarketplaceListing = (listingId: string) => {
  const listing = demoMarketplace.find(l => l.id === listingId);
  if (listing) {
    return Promise.resolve(listing);
  }
  return Promise.reject(new Error('Listing not found'));
};

export const getDemoUserListings = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoMarketplace.filter(l => l.sellerAddress === demoUser.walletAddress));
  }
  return Promise.resolve([]);
};

// Sales services
export const getDemoSales = () => {
  return Promise.resolve(demoSales);
};

export const getDemoUserSales = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoSales.filter(s => 
      s.sellerAddress === demoUser.walletAddress || s.buyerAddress === demoUser.walletAddress
    ));
  }
  return Promise.resolve([]);
};

// Tip services
export const getDemoTips = () => {
  return Promise.resolve(demoTips);
};

export const getDemoUserReceivedTips = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoTips.filter(t => t.toUserAddress === demoUser.walletAddress));
  }
  return Promise.resolve([]);
};

export const getDemoUserSentTips = (userId: string) => {
  if (userId === 'demo' || userId === demoUser.id || userId === demoUser.walletAddress) {
    return Promise.resolve(demoTips.filter(t => t.fromUserAddress === demoUser.walletAddress));
  }
  return Promise.resolve([]);
};

// Governance services
export const getDemoProposals = () => {
  return Promise.resolve(demoProposals);
};

export const getDemoProposal = (proposalId: string) => {
  const proposal = demoProposals.find(p => p.id === proposalId);
  if (proposal) {
    return Promise.resolve(proposal);
  }
  return Promise.reject(new Error('Proposal not found'));
};

export const getDemoTreasury = () => {
  return Promise.resolve(demoTreasury);
};

// Analytics services
export const getDemoAnalytics = () => {
  return Promise.resolve(demoAnalytics);
};